module.exports = __webpack_public_path__ + "img/mb_2.8c9373ab.jpg";